<template>
  <div class="team-list-item">
    <div class="team-list-item__image">
      <UserAvatar
        class="team-list-item__image__resource"
        :image="item.image ? previewImageURL : null"
        :name="`${item.name.first} ${item.name.last}`"
        :email="item.title"
      />
    </div>
    <div class="team-list-item__body">
      <div class="team-list-item__name">
        {{ item.name.first }} {{ item.name.last }}
      </div>
      <div v-if="item.email" class="team-list-item__email">
        {{ item.email }}
      </div>
      <div v-else class="team-list-item__title">{{ item.title }}</div>
    </div>
    <div class="team-list-item__buttons">
      <button class="btn btn-link" @click="$emit('edit', item)">
        <span>Edit</span>
      </button>
      <button class="btn btn-link" @click="$emit('remove', item)">
        <span>Remove</span>
      </button>
    </div>
  </div>
</template>

<script>
import UserAvatar from '@/components/user/UserAvatar'
import Image from '@/models/Image'

export default {
  name: 'TeamListItem',
  components: { UserAvatar },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      RESOURCE_BASE_URL: process.env.RESOURCE_BASE_URL
    }
  },
  computed: {
    previewImageURL() {
      if (!this.item.image) {
        return
      }

      const temp = new Image(this.item.image)
      return temp.thumbnailSizeUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.team-list-item {
  display: flex;
  justify-content: stretch;
  align-items: center;

  &__image {
    flex: 0 0 auto;
    width: 60px;
    height: 60px;

    &__resource {
      width: 100%;
      height: 100%;
      object-fit: cover;
      overflow: hidden;
      line-height: 0;
    }
  }

  &__body {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  &__name {
    flex: 0 1 250px;
    padding: 0 1rem;
    word-break: break-all;
  }

  &__title {
    flex: 1 1 auto;
    padding: 0 1rem 0 0;
    word-break: break-all;
  }

  &__email {
    flex: 1 1 auto;
    padding: 0 1rem 0 0;
    word-break: break-all;
    text-align: right;
  }

  &__buttons {
    flex: 0 0 auto;

    button {
      margin-right: 1rem;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
